import { cn } from 'helpers/cn';

type EventTagProps = { children: React.ReactNode; tone?: 'event' | 'muted' };

/** A small tag beside an objective: the event a default resolves to, or a note like "not mapped". */
export const EventTag = ({ children, tone = 'event' }: EventTagProps) => (
  <span
    className={cn(
      'bg-field text-dim shrink-0 rounded-md px-2 py-0.5 text-micro',
      tone === 'event' ? 'font-mono' : 'font-sans',
    )}
  >
    {children}
  </span>
);
